import React from 'react';
import { useNavigate } from 'react-router-dom'
import { getRegion } from '../../../../../../../../utils/Region';
import useRenderChapas from './../../../../../../../../hooks/useRenderChapas';
//--------------------------------------------------------------------------------
import { FadeInImage } from '../../../../../../../../components/FadeInImage';
import './style.scss';
import { checkIfChannelIsBlocked } from '../../../../../../../EPG/actions/channelBlocker/blocker.actions';
import { useDispatch } from 'react-redux';
import useMenuRedirect from '../../../../../../../Menu/hooks/useMenuRedirect';
import { pushSelectContentEvent } from 'utils/analytics/pushSelectContentEvent';
import {PUSHTOHISTORY} from 'constants.js'
import { getContentListV1 } from 'utils/homologacion/homologacion';

export const HighlightCard = React.forwardRef(
  ({ contentInfo, isMobile, carouselTitle, contentPosition, setIdCardRef }, ref) => {
    const dispatch = useDispatch();
    const { renderLabel } = useRenderChapas();
    const isLiveContent = getContentListV1?.IsLive(contentInfo);
    const groudId = contentInfo?.group_id;
    const url = contentInfo?.url || '';
    const path = window.location.origin;
    const { navigateToChannel, nodesSelected } = useMenuRedirect();
    const navigate = useNavigate()

    const handleCardClick = e => {
      e.stopPropagation();

      pushSelectContentEvent(contentInfo, nodesSelected, carouselTitle, contentPosition);

      //Redireccionamiento
      if (contentInfo?.type === 'app_behaviour') {
        location.href = contentInfo?.app_behaviour;
      } else if (contentInfo?.type === 'special') {
        window.location = `${path}${url.replace(/\.php/g, '')}`;
      } else if (contentInfo?.type === 'node') {
        navigate(`/${getRegion()}/${contentInfo?.section}`);
      } else if (isLiveContent) {
        navigateToChannel({ id: groudId }, PUSHTOHISTORY);
      } else {
        navigate(
          `/${getRegion()}/vcard/homeuser/${contentInfo?.title_uri}/${groudId}`,
        );
      }
    };

    return (
        <div className="highlight-card" onClick={handleCardClick} onTouchStart={()=>setIdCardRef(contentInfo?.url)} ref={ref}>
        {renderLabel(contentInfo, true)}
        <FadeInImage
          imageAlt={'clarovideo'}
          imageSrc={`${
            isMobile ? contentInfo?.image_medium : contentInfo?.image_highlight
          }`}
          width={isMobile ? '272px' : '1248px'}
          height={isMobile ? '408px' : '299.19px'}
          classNames={['highlight-card__image']}
        />
      </div>
    );
  },
);
